import { render, staticRenderFns } from "./OpeningBalanceEdit.vue?vue&type=template&id=0e07d5b2&scoped=true"
import script from "./OpeningBalanceEdit.vue?vue&type=script&lang=js"
export * from "./OpeningBalanceEdit.vue?vue&type=script&lang=js"
import style0 from "./OpeningBalanceEdit.vue?vue&type=style&index=0&id=0e07d5b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e07d5b2",
  null
  
)

export default component.exports